export default __webpack_public_path__ + "static/media/LoginBackground.677baca9.jpg";